import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        event: '=',
        courses: '=',
        context: '='
    },
    template: `
    <div ng-if="!vm.canAdministrate() && vm.context==='edit'" class="alert alert-warn ng-scope">
        {{ 'events.Changes are not allowed due to privileges' | translate }}
    </div>
    <div class="well color01">
        <div class="form">
        <div class="alert alert-danger" ng-if="vm.error">{{ vm.error }}</div>
        <form-row error="vm.form.errors.name">
            <label class="label">{{ 'filter.Name' | translate }}</label>
            <div class="items">
                <input type="text" ng-model="vm.form.model.name" class="form-control"/>
                <form-row-error></form-row-error>
            </div>
        </form-row>
        <form-row ng-if="vm.context==='edit'">
            <label class="label">{{ 'general.Active' | translate }}</label>
            <div class="items">
                <label class="switch01">
                    <input ng-model="vm.form.model.isActive" type="checkbox" name="switch">
                    <span>Yes</span>
                </label>
            </div>
        </form-row>
        <form-row error="vm.form.errors.trigger">
            <label class="label">{{ 'events.Trigger' | translate }}</label>
            <div class="items">
                <select ng-change="vm.toggleTrigger()" class="form-control" ng-model="vm.form.model.trigger">
                    <option value="EMPLOYEE_ENROLLED_TO_COURSE">{{ 'events.Employee enrolled to course' | translate }}</option>
                    <option value="EMPLOYEE_HAS_NOT_PASSED_TRAINING_MODULE">{{ 'events.Employee has not passed training module' | translate }}</option>
                    <option value="TRAINING_EDITED">{{ 'events.Training edited' | translate }}</option>
                    <option value="CERTIFICATE_EXPIRING">{{ 'events.Certificate expiring' | translate }}</option>
                </select>
                <form-row-error></form-row-error>
            </div>
        </form-row>
        <form-row error="vm.form.errors.courseIds" ng-if="vm.form.model.trigger && vm.form.model.trigger!=='CERTIFICATE_EXPIRING'">
            <label class="label">{{ 'course.Courses' | translate }}</label>
            <div class="items">
                <div ng-dropdown-multiselect=""
                    options="vm.multiFilter.courses.options"
                    selected-model="vm.multiFilter.courses.models"
                    extra-settings="vm.multiFilter.courses.settings"
                    events="vm.multiFilter.courses.events"
                    translation-texts="vm.multiFilter.courses.translations"
                    disabled="vm.isDropDownDisabled()"
                ></div>
                <form-row-error></form-row-error>
            </div>
        </form-row>
        <div style="height:200px" class="loader01 changelog-item" ng-if="vm.loading"></div>
        <div ng-if="!vm.loading">
            <form-row error="vm.form.errors.action">
                <label class="label">{{ 'events.Action' | translate }}</label>
                <div class="items">
                    <select ng-if="vm.form.model.trigger==='EMPLOYEE_ENROLLED_TO_COURSE'" ng-change="vm.toggleAction()" class="form-control" ng-model="vm.form.model.action">
                        <option value="SEND_COURSE_NOTIFICATION">{{ 'events.SEND_COURSE_NOTIFICATION' | translate }}</option>
                        <option value="SEND_INDIVIDUAL_NOTIFICATIONS">{{ 'events.SEND_INDIVIDUAL_NOTIFICATIONS' | translate }}</option>
                        <option value="DO_NOT_SEND_NOTIFICATION">{{ 'events.DO_NOT_SEND_NOTIFICATION' | translate }}</option>
                    </select>
                    <select ng-if="vm.form.model.trigger==='EMPLOYEE_HAS_NOT_PASSED_TRAINING_MODULE'" ng-change="vm.toggleAction()" class="form-control" ng-model="vm.form.model.action">
                        <option value="SEND_INDIVIDUAL_NOTIFICATIONS">{{ 'events.SEND_INDIVIDUAL_NOTIFICATIONS' | translate }}</option>
                        <option value="DO_NOT_SEND_NOTIFICATION">{{ 'events.DO_NOT_SEND_NOTIFICATION' | translate }}</option>
                    </select>
                    <select ng-if="vm.form.model.trigger==='TRAINING_EDITED'" ng-change="vm.toggleAction()" class="form-control" ng-model="vm.form.model.action">
                        <option value="SEND_INDIVIDUAL_NOTIFICATIONS">{{ 'events.SEND_INDIVIDUAL_NOTIFICATIONS' | translate }}</option>
                        <option value="DO_NOT_SEND_NOTIFICATION">{{ 'events.DO_NOT_SEND_NOTIFICATION' | translate }}</option>
                    </select>
                    <select ng-if="vm.form.model.trigger==='CERTIFICATE_EXPIRING'" ng-change="vm.toggleAction()" class="form-control" ng-model="vm.form.model.action">
                        <option value="SEND_NOTIFICATION_FOR_ALL_COURSES">{{ 'events.SEND_NOTIFICATION_FOR_ALL_COURSES' | translate }}</option>
                        <option ng-if="vm.isExternalParticipationsEnabled()" value="SEND_NOTIFICATION_FOR_EXTERNAL_COURSES_ONLY">
                            {{ 'events.SEND_NOTIFICATION_FOR_EXTERNAL_COURSES_ONLY' | translate }}
                        </option>
                    </select>
                    <form-row-error></form-row-error>
                </div>
            </form-row>

            <!-- Child components: everything below Trigger/Action is split -->
            <events-partials-detail-cert-expire
                ng-if="vm.form.model.trigger==='CERTIFICATE_EXPIRING'"
                form="vm.form"
                activetype="vm.activetype"
                enums="vm.enums"
                default-language="vm.defaultLanguage"
                helpers="vm.childHelpers"
                ckconfig="vm.ckconfig"
            ></events-partials-detail-cert-expire>

            <events-partials-detail-default
                ng-if="vm.form.model.trigger!=='CERTIFICATE_EXPIRING' &&
                       vm.form.model.action!=='DO_NOT_SEND_NOTIFICATION' &&
                       (vm.multiFilter.courses.models.length > 0 || vm.form.model.templates.length > 0)"
                form="vm.form"
                activetype="vm.activetype"
                enums="vm.enums"
                default-language="vm.defaultLanguage"
                helpers="vm.childHelpers"
                ckconfig="vm.ckconfig"
            ></events-partials-detail-default>
        </div>
    </div>
	<ul class="actions01">
		<li ng-if="vm.canAdministrate() || vm.context==='add'" class="primary"><a ng-click="vm.save()" class="btn main">{{ 'general.Save' | translate }}</a></li>
		<li class="secondary"><a ui-sref="authorized.events.list()" class="btn discrete">{{ 'general.Back' | translate }}</a></li>
    </ul>
    `
})
export default class {
    constructor ($translate, lodash, toastr, DATATABLES, FormFactory, EventResource, ModalService, USER_STATUS_ENUM, PrivilegeService,
        FilterService, TokenService, COMPANY_LANGUAGE_ENUM, OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM, COURSE_TRAINING_TYPE_ENUM, $state,
        CkEditorService) {
        this.$translate = $translate;
        this.$state = $state;
        this.toastr = toastr;
        this.DATATABLES = DATATABLES;
        this.ModalService = ModalService;
        this.PrivilegeService = PrivilegeService;
        this.FormFactory = FormFactory;
        this.EventResource = EventResource;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.COMPANY_LANGUAGE_ENUM = COMPANY_LANGUAGE_ENUM;
        this.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM = OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM;
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
        this.lodash = lodash;
        this.FilterService = FilterService;
        this.TokenService = TokenService;
        this.CkEditorService = CkEditorService;

        this.ckconfig = this.CkEditorService.getNotificationConfig();

        // Regex for validating emails in tags-input
        this.emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        this.selectedCourses = [];
        this.defaultLanguage = this.TokenService.getCompanyLanguage();
        this.languages = {};
        this.loading = false;

        // State cache isolated by TRIGGER only
        this._stateCacheByTrigger = {};
        this._lastTrigger = null;
        this._reqId = 0;
    }

    $onInit () {
        this.initMultiFilter();
        this.initForm(this.event);

        // Expose enums for child components
        this.enums = {
            COMPANY_LANGUAGE_ENUM: this.COMPANY_LANGUAGE_ENUM,
            OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM: this.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM,
            COURSE_TRAINING_TYPE_ENUM: this.COURSE_TRAINING_TYPE_ENUM
        };

        // Bridge helpers for child components (bind to parent context)
        this.childHelpers = {
            getVariables: (t) => this.getVariables(t),
            getTag: (v) => this.getTag(v),
            isModuleEnabled: (m) => this.isModuleEnabled(m),
            onIntervalChange: (item) => this.onIntervalChange(item),
            clampReminder: (item) => this.clampReminder(item),
            deleteTime: (i, times) => this.deleteTime(i, times),
            addNewTime: (arr) => this.addNewTime(arr),
            changeStatus: (i18n) => this.changeStatus(i18n),
            preview: (tplI18n) => this.preview(tplI18n),
            previewNotification: (tplI18n) => this.previewNotification(tplI18n),
            getSortedLanguages: (i18ns) => this.getSortedLanguages(i18ns),
            preventNonNumeric: (e) => this.preventNonNumeric(e)
        };

        this.initialTemplates = [];
        if (this.form.model.trigger) {
            this.initialTemplates[this.form.model.trigger] = this.form.model.templates;
            // seed trigger-scoped cache from initial data
            this._cacheCurrentTriggerState();
            // Only fetch default templates when adding a new event
            // For existing events, templates are already loaded via expand in initForm()
            if (this.context === 'add') {
                const missingAsDisabled = this.form.model.trigger !== 'CERTIFICATE_EXPIRING';
                this.setTemplates(missingAsDisabled);
            }
        }
    }

    canAdministrate () {
        if (this.event.createdBy !== undefined) {
            return this.PrivilegeService.canAdministrateEvents() || this.event.createdBy.id === this.TokenService.getUser().id;
        }
        return this.PrivilegeService.canAdministrateEvents();
    }

    addNewTime (array) {
        array.push({
            interval: 5,
            intervalType: 'DAY',
            type: (this.form && this.form.model &&
                this.form.model.trigger === 'CERTIFICATE_EXPIRING')
                ? 'BEFORE_CERTIFICATE_EXPIRATION'
                : 'BEFORE_TRAINING_DEADLINE'
        });
        return array;
    }

    clampReminder (item) {
        const val = parseInt(item.interval, 10);
        item.interval = isNaN(val) || val < 0 ? 0 : val;

        const limits = { DAY: 365, WEEK: 52, MONTH: 12 };
        const max = limits[item.intervalType] || 365;
        if (item.interval > max) {
            item.interval = max;
        }
        if (item.interval < 1) {
            item.interval = 1;
        }
    }

    deleteTime (index, times) {
        times.splice(index, 1);
    }

    toggleAction () {
        if (this.form.model.trigger === 'CERTIFICATE_EXPIRING') {
            // For CERT: only update activetype, preserve all state
            this.activetype = 'default';
            this._cacheCurrentTriggerState();
        }
        else {
            // For non-CERT triggers: fetch fresh templates (original behavior)
            this.setTemplates();
            this.initialTemplates[this.form.model.trigger] = this.form.model.templates;
            this.activetype = this.computeActiveType(
                this.form.model.trigger,
                this.form.model.action
            );
        }
    }

    toggleTrigger () {
        const oldTrigger = this._lastTrigger || this.form.model.trigger;

        // Only cache for CERT_EXPIRING (to preserve unsaved edits)
        if (oldTrigger === 'CERTIFICATE_EXPIRING') {
            this._cacheCurrentTriggerState(oldTrigger);
        }

        // Normalize default action for the selected trigger
        if (this.form.model.trigger === 'EMPLOYEE_HAS_NOT_PASSED_TRAINING_MODULE' ||
            this.form.model.trigger === 'TRAINING_EDITED') {
            this.form.model.action = 'SEND_INDIVIDUAL_NOTIFICATIONS';
        }
        if (this.form.model.trigger === 'CERTIFICATE_EXPIRING') {
            this.form.model.action = 'SEND_NOTIFICATION_FOR_ALL_COURSES';
            // clear multi-select since courses are not used in this trigger
            if (this.multiFilter && this.multiFilter.courses) {
                this.multiFilter.courses.models = [];
            }
        }
        if (this.form.model.trigger === 'EMPLOYEE_ENROLLED_TO_COURSE') {
            this.form.model.action = 'SEND_COURSE_NOTIFICATION';
        }

        // Only try to restore cache for CERT_EXPIRING
        const restored = (this.form.model.trigger === 'CERTIFICATE_EXPIRING')
            ? this._restoreStateForTrigger(this.form.model.trigger)
            : false;

        if (!restored) {
            // For non-CERT triggers, always fetch fresh with defaults enabled
            // For CERT, fetch and let setTemplates handle the logic
            this.setTemplates(false);
        }

        this.initialTemplates[this.form.model.trigger] = this.form.model.templates;
        this.activetype = this.computeActiveType(
            this.form.model.trigger,
            this.form.model.action
        );
        this._lastTrigger = this.form.model.trigger;

        // Only cache for CERT_EXPIRING after switch
        if (this.form.model.trigger === 'CERTIFICATE_EXPIRING') {
            this._cacheCurrentTriggerState(this.form.model.trigger);
        }
    }


    getSortedLanguages (templateI18ns) {
        if (!templateI18ns || typeof templateI18ns !== 'object') {
            return [];
        }
        const companySupportedLanguages = this.TokenService.getCompanySupportedLanguages();
        const sorted = [];
        // default language first, if present
        const def = templateI18ns[this.defaultLanguage];
        if (def) {
            sorted.push(def);
        }
        // then other supported languages that exist
        this.lodash.forEach(companySupportedLanguages, (code) => {
            if (code !== this.defaultLanguage && this.lodash.has(templateI18ns, code)) {
                const tpl = templateI18ns[code];
                if (tpl) {
                    sorted.push(tpl);
                }
            }
        });
        return sorted;
    }

    _cacheCurrentTriggerState (trigger) {
        const key = trigger || (this.form && this.form.model && this.form.model.trigger);
        if (!key) return;
        const snapshot = {
            templates: this.lodash.cloneDeep(this.form.model.templates || []),
            activetype: this.activetype,
            coursesModels: this.lodash.cloneDeep(this.multiFilter && this.multiFilter.courses ? this.multiFilter.courses.models : [])
        };
        this._stateCacheByTrigger[key] = snapshot;
        this._lastTrigger = key;
    }

    _restoreStateForTrigger (trigger) {
        const snap = this._stateCacheByTrigger[trigger];
        if (!snap) return false;
        const validTemplates = Array.isArray(snap.templates) && snap.templates.some(t => t && t.moduleType);
        if (!validTemplates) return false;

        // Normalize templateI18ns to object maps
        const restored = this.lodash.cloneDeep(snap.templates).map(t => Object.assign({}, t, {
            templateI18ns: (t.templateI18ns && typeof t.templateI18ns === 'object') ? t.templateI18ns : {},
            times: Array.isArray(t.times) && t.times.length ? t.times : this.addNewTime([])
        }));

        this.form.model.templates = restored;
        this.activetype = snap.activetype || this.activetype;

        // Restore course selection for non-CERT triggers
        if (trigger !== 'CERTIFICATE_EXPIRING' && this.multiFilter && this.multiFilter.courses) {
            this.multiFilter.courses.models = this.lodash.cloneDeep(snap.coursesModels || []);
        }
        this._lastTrigger = trigger;
        return true;
    }

    initForm (event) {
        this.form = this.FormFactory.createFromResource(event, {
            expand: 'templates.templateI18ns,courses,templates.times,createdBy'
        });
        if (!this.form.model.action) {
            this.form.model.action = this.form.model.trigger === 'CERTIFICATE_EXPIRING'
                ? 'SEND_NOTIFICATION_FOR_ALL_COURSES'
                : 'SEND_COURSE_NOTIFICATION';
        }
        if (!this.activetype) {
            if (this.form.model.trigger === 'CERTIFICATE_EXPIRING') {
                this.activetype = 'default';
            }
            else {
                this.activetype = this.computeActiveType(
                    this.form.model.trigger,
                    this.form.model.action
                );
            }
        }
        this.form.model.templates = this.normalizeTemplates(this.form.model.templates);
    }

    normalizeTemplates (templates) {
        return this.lodash.map(templates, (template) => {
            // accept either ['a@x.com'] or [{text:'a@x.com'}]
            const custom = Array.isArray(template.customEmails)
                ? template.customEmails.map(x => (typeof x === 'string' ? x : (x && x.text))).filter(Boolean)
                : [];

            // Ensure times array has at least one entry with proper defaults
            let times = template.times;
            if (!Array.isArray(times) || times.length === 0) {
                times = this.addNewTime([]);
            }
            else {
                // Ensure each time entry has the correct type field for the current trigger
                const isCert = this.form && this.form.model && this.form.model.trigger === 'CERTIFICATE_EXPIRING';
                const defaultType = isCert ? 'BEFORE_CERTIFICATE_EXPIRATION' : 'BEFORE_TRAINING_DEADLINE';
                times = times.map(t => {
                    // If type is missing or doesn't match current trigger context, set default
                    if (!t.type || (isCert && t.type !== 'BEFORE_CERTIFICATE_EXPIRATION' && t.type !== 'AFTER_CERTIFICATE_EXPIRATION')) {
                        return Object.assign({}, t, { type: defaultType });
                    }
                    return t;
                });
            }

            return {
                id: template.id,
                moduleType: template.moduleType,
                templateI18ns: template.templateI18ns,
                sendIcalFile: (this.form && this.form.model && this.form.model.trigger === 'CERTIFICATE_EXPIRING') ? false : !!template.sendIcalFile,
                isEnabled: template.isEnabled,
                times,
                recipient: (typeof template.recipient === 'string' ? template.recipient : 'RELATED_EMPLOYEE'),
                customEmails: custom
            };
        });
    }

    getVariables (template) {
        if (!template || !template.templateI18ns || typeof template.templateI18ns !== 'object') {
            return [];
        }
        // Prefer company default language entry; otherwise first available
        const i18n = template.templateI18ns[this.defaultLanguage] || Object.values(template.templateI18ns)[0];
        if (!i18n || !i18n.variablesJson) {
            return [];
        }
        let vars = i18n.variablesJson;
        if (typeof vars === 'string') {
            try {
                vars = JSON.parse(vars);
            }
            catch (e) {
                return [];
            }
        }
        if (Array.isArray(vars)) {
            return vars;
        }
        if (typeof vars === 'object' && vars !== null) {
            return Object.getOwnPropertyNames(vars);
        }
        return [];
    }

    changeStatus (templateI18n) {
        if (templateI18n.status === 'ACTIVE') {
            templateI18n.status = 'INACTIVE';
        }
        else {
            templateI18n.status = 'ACTIVE';
        }
    }

    initMultiFilter () {
        this.allCoursesOption = {
            value: 0,
            label: this.$translate.instant('general.All courses')
        };

        const courseOptions = this.getCourseOptions();
        // NOTE: selectedOptions objects must be same as site options objects for multiselect to work
        const selectedCourseOptions = this.getSelectedCourseOptions(courseOptions);


        this.multiFilter = {
            courses: {
                models: selectedCourseOptions,
                options: courseOptions,
                settings: {
                    enableSearch: true,
                    checkBoxes: true,
                    showCheckAll: false,
                    showUncheckAll: false,
                    smartButtonMaxItems: 5,
                    smartButtonTextConverter: (itemText) => itemText
                },
                events: {
                    onItemDeselect: this.getSiteItemCallback(),
                    onItemSelect: this.getSiteItemCallback()
                },
                translations: {
                    buttonDefaultText: this.$translate.instant('filter.Select')
                }
            }
        };
    }

    getSiteItemCallback () {
        return item => {
            const { multiFilter } = this;
            // if all sites option, set only it, otherwise deselect all sites if checkbox is selected
            if (item.value === 0) {
                multiFilter.courses.models = [this.allCoursesOption];
            }
            else {
                multiFilter.courses.models = multiFilter.courses.models.filter(model => model.value !== 0);
            }
        };
    }

    getCourseOptions () {
        const courseOptions = [];
        const cb = course => {
            return {
                value: course.id,
                label: course.activeI18n.name
            };
        };

        // 1. map all sites option if its selected or if user can manage site access
        if (this.isDropDownDisabled()) {
            courseOptions.push(this.allCoursesOption);
        }
        else {
            if (this.PrivilegeService.isCompanyAdmin()) {
                courseOptions.push(this.allCoursesOption);
            }
        }

        // 2. map sites that user has access to via privileges
        this.lodash.forEach(this.courses, course => {
            courseOptions.push(cb(course));
        });

        return this.lodash.uniqBy(courseOptions, option => option.value);
    }

    getSelectedCourseOptions (courseOptions) {
        let selectedOptions = [];

        if (this.context === 'add') {
            // Default to "All courses" in add context when available
            if (this.PrivilegeService.isCompanyAdmin() && this.allCoursesOption) {
                selectedOptions.push(this.allCoursesOption);
            }
            return selectedOptions;
        }

        if (this.event.courses && !this.event.courses.length) {
            selectedOptions.push(this.allCoursesOption);
        }
        else {
            const selectedCourseIds = this.event.courses.map(course => course.id);
            selectedOptions = courseOptions.filter(option => this.lodash.includes(selectedCourseIds, option.value));
        }

        return selectedOptions;
    }

    isDropDownDisabled () {
        // if edit view
        // if All courses selected previously
        // if no company privileges
        return this.context === 'edit' && !this.PrivilegeService.isCompanyAdmin() && !this.event.courses.length;
    }

    beforeSave () {
        // For CERTIFICATE_EXPIRING, all templates are implicitly enabled (no isEnabled toggle in UI)
        // For other triggers, filter by isEnabled field
        let templates = this.form.model.trigger === 'CERTIFICATE_EXPIRING'
            ? this.form.model.templates.slice()
            : this.lodash.filter(this.form.model.templates, t => t.isEnabled);

        templates.forEach(t => {
            if (t.recipient === 'CUSTOM_EMAIL') {
                if (Array.isArray(t.customEmails)) {
                    t.customEmails = t.customEmails
                        .map(x => (typeof x === 'string' ? x : (x && x.text)))
                        .map(s => (s || '').trim())
                        .filter(Boolean);
                }
                else {
                    t.customEmails = [];
                }
            }
        });

        // Send only languages enabled for the company; stored translations of other languages are left untouched
        const enabledLanguages = new Set(this.TokenService.getCompanySupportedLanguages());
        templates = templates.map(t => {
            const src = t.templateI18ns || {};
            const pruned = {};
            Object.keys(src).forEach(code => {
                if (src[code] && enabledLanguages.has(code)) {
                    pruned[code] = src[code];
                }
            });
            return Object.assign({}, t, { templateI18ns: pruned });
        });

        // Filter out templates with no valid templateI18ns (backend requires at least one i18n with id)
        templates = templates.filter(t => {
            const i18ns = t.templateI18ns || {};
            const keys = Object.keys(i18ns);
            // Keep template only if it has at least one i18n entry with a valid id
            return keys.length > 0 && keys.some(key => i18ns[key] && i18ns[key].id);
        });

        if (this.form.model.trigger === 'CERTIFICATE_EXPIRING') {
            templates = templates.map(t => {
                const copy = Object.assign({}, t, { sendIcalFile: false });
                if (copy.templateI18ns) {
                    Object.keys(copy.templateI18ns).forEach(lang => {
                        if ('calenderContent' in copy.templateI18ns[lang]) {
                            copy.templateI18ns[lang].calenderContent = null;
                        }
                    });
                }
                return copy;
            });

            templates = templates
                .filter(t => (t.moduleType === 'default' || t.moduleType === 'ALL'))
                .map(t => {
                    const times = Array.isArray(t.times) ? t.times : [];
                    const normalizedTimes = times.map(time => ({
                        id: time.id,
                        templateId: time.templateId,
                        interval: time.interval,
                        intervalType: time.intervalType,
                        type: (time.type === 'AFTER_CERTIFICATE_EXPIRATION' ||
                            time.type === 'BEFORE_CERTIFICATE_EXPIRATION')
                            ? time.type
                            : 'BEFORE_CERTIFICATE_EXPIRATION'
                    }));
                    return Object.assign({}, t, { times: normalizedTimes });
                });

            if (!templates.length) {
                this.error = this.$translate.instant('events.Please select at least one training module');
                this.loading = false;
                throw new Error('no-templates');
            }
        }

        this.form.model.templates = templates;
    }

    save () {
        this.loading = true;
        this.beforeSave();
        this.error = false;

        let courseIds;
        if (this.form.model.trigger === 'CERTIFICATE_EXPIRING') {
            courseIds = [-1];
        }
        else {
            courseIds = !this.multiFilter.courses.models.length
                ? [-1]
                : this.multiFilter.courses.models.map(c => c.value);
        }
        courseIds = courseIds.filter(v => v !== null);
        this.form.model.courseIds = courseIds;

        this.form.save().then((response) => {
            this.loading = false;
            if (this.context === 'add') {
                this.toastr.success(this.$translate.instant('notification.Notification add'));
                this.$state.go('authorized.events.edit', { id: response.id });
            }
            else {
                this.event = response;
                this.initForm(response);
                this.initialTemplates[this.form.model.trigger] = this.form.model.templates;
                // Update cache with saved data to keep consistency
                this._cacheCurrentTriggerState(this.form.model.trigger);
                // No need to call setTemplates() here - initForm already populated templates from response
                this.toastr.success(this.$translate.instant('notification.Notification modify'));
            }
        }).catch((errors) => {
            this.loading = false;
            if (errors.data && errors.data.length) {
                this.error = errors.data[0].message;
                window.scrollTo(0, 0);
                // Don't reload templates on validation error - preserve user's unsaved edits
            }
        }).finally(() => {
            this.loading = false;
        });
    }

    setTemplates (missingTemplatesAsDisabled = false) {
        // Request guard to avoid stale overwrites on rapid toggles
        const rid = ++this._reqId;
        const trigger = this.form.model.trigger;
        const isCert = trigger === 'CERTIFICATE_EXPIRING';
        // Keep showing what we have during loading to avoid blank UI
        this.loading = true;

        this.EventResource.templates({ action: this.form.model.action, trigger }).$promise
            .then((templates) => {
                if (rid !== this._reqId) return; // stale response

                delete templates.$promise;
                delete templates.$resolved;

                // Stage results here, then swap atomically
                const staged = [];
                const cached = (this._stateCacheByTrigger[trigger] && this._stateCacheByTrigger[trigger].templates)
                    ? this._stateCacheByTrigger[trigger].templates
                    : [];

                const isEquivalent = (a, b) => {
                    if (!isCert) return a === b;
                    const set = new Set(['default', 'ALL']);
                    return (a === b) || (set.has(a) && set.has(b));
                };

                // Build from API response (by moduleType)
                this.lodash.forEach(templates, (languages, moduleType) => {
                    if (isCert && !languages) {
                        // Skip empty placeholder buckets (e.g., 'default': null)
                        return;
                    }

                    // Try to merge with cached template for THIS trigger
                    const cachedTpl = this.lodash.find(cached, t => t && isEquivalent(t.moduleType, moduleType));

                    if (cachedTpl) {
                        // Merge: keep user edits, adopt languages from API when missing
                        const mergedI18ns = Object.assign({}, (cachedTpl.templateI18ns || {}), (languages || {}));
                        staged.push({
                            moduleType,
                            templateI18ns: mergedI18ns,
                            sendIcalFile: isCert ? false : !!cachedTpl.sendIcalFile,
                            recipient: cachedTpl.recipient || 'RELATED_EMPLOYEE',
                            customEmails: Array.isArray(cachedTpl.customEmails) ? cachedTpl.customEmails : [],
                            isEnabled: typeof cachedTpl.isEnabled === 'boolean' ? cachedTpl.isEnabled : (!missingTemplatesAsDisabled && this.isModuleEnabled(moduleType)),
                            times: Array.isArray(cachedTpl.times) && cachedTpl.times.length ? cachedTpl.times : this.addNewTime([])
                        });
                    }
                    else {
                        // Initialize from API
                        staged.push({
                            moduleType,
                            templateI18ns: languages || {},
                            sendIcalFile: !isCert,
                            recipient: 'RELATED_EMPLOYEE',
                            customEmails: [],
                            isEnabled: missingTemplatesAsDisabled ? false : this.isModuleEnabled(moduleType),
                            times: this.addNewTime([])
                        });
                    }
                });

                // Swap atomically
                this.form.model.templates = staged.map(t => Object.assign({}, t, {
                    templateI18ns: t.templateI18ns || {}
                }));

                // Recompute/validate activetype
                if (isCert) {
                    const hasExact = this.form.model.templates.some(t => t.moduleType === this.activetype || isEquivalent(t.moduleType, this.activetype));
                    if (!hasExact) {
                        const first = this.form.model.templates[0];
                        if (first && first.moduleType) this.activetype = first.moduleType;
                        else this.activetype = 'default';
                    }
                }
                else {
                    const desired = this.computeActiveType(trigger, this.form.model.action);
                    const exists = this.form.model.templates.some(t => t.moduleType === desired);
                    this.activetype = exists ? desired : (this.form.model.templates[0] && this.form.model.templates[0].moduleType);
                }

                // Update cache for this trigger with freshly staged data
                this._cacheCurrentTriggerState(trigger);
            })
            .catch((err) => {
                if (rid !== this._reqId) return; // stale response
                const msg = (err && err.data && (err.data.message || err.data.error)) || this.$translate.instant('notification.Error');
                this.error = msg;
                if (this.toastr && typeof this.toastr.error === 'function') {
                    this.toastr.error(msg);
                }
            })
            .finally(() => {
                if (rid === this._reqId) this.loading = false;
            });
    }

    preview (template) {
        this.previewTemplate = template;
        return this.ModalService.open({
            template: '<modals-template-preview template-i18n="vm.previewTemplate" class="wrapper" cancel="vm.$uibModalInstance.dismiss()"/>',
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.previewTemplate = template;
            }
        });
    }

    previewNotification (template) {
        this.previewTemplate = template;
        return this.ModalService.open({
            template: '<modals-template-preview-notification template-i18n="vm.previewTemplate" class="wrapper" cancel="vm.$uibModalInstance.dismiss()"/>',
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.previewTemplate = template;
            }
        });
    }

    isExternalParticipationsEnabled () {
        return !!(this.TokenService &&
            this.TokenService.isExternalParticipationModuleEnabled &&
            this.TokenService.isExternalParticipationModuleEnabled());
    }

    isModuleEnabled (moduleType) {
        if (moduleType === 'TEST') {
            return !!this.TokenService.isFormModuleEnabled();
        }
        if (moduleType === 'WEBINAR') {
            return !!this.TokenService.isFormModuleEnabled();
        }
        // by default ebabled
        return true;
    }

    computeActiveType (trigger, action) {
        if (trigger === 'CERTIFICATE_EXPIRING') {
            return 'default';
        }
        if (action === 'SEND_COURSE_NOTIFICATION') {
            return 'default';
        }
        return 'ONLINE';
    }

    getTag (variable) {
        return `{{ ${variable} }}`;
    }

    onIntervalChange (item) {
        if (item.interval === '' || item.interval === null || typeof item.interval === 'undefined') {
            // allow user to clear the field
            return;
        }
        this.clampReminder(item);
    }

    preventNonNumeric (e) {
        // allow navigation & control keys
        const allowed = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
        if (allowed.includes(e.key)) return;

        // block anything not 0–9
        if (!/^[0-9]$/.test(e.key)) {
            e.preventDefault();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/events/partials/detail/index.js